import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
export function parseTemplate(template, data) {
  var reg = new RegExp('{{([^}]*)}}', 'gi');
  return (template || '').replace(reg, function ($1, key) {
    var arr = key.split('.');
    var val = data;

    for (var i = 0; i < arr.length; i += 1) {
      // eslint-disable-next-line no-shadow
      var _key = arr[i].trim();

      val = val[_key];
    }

    return val || '';
  });
}
export function removeHttp(src) {
  if (!src) return src;

  if (_typeof(src) === 'object' && src.backgroundImage) {
    // eslint-disable-next-line no-param-reassign
    src.backgroundImage = src.backgroundImage.replace(/^http(s?):/, '');
    return src;
  }

  return src.replace(/^http(s?):/, '');
}
/**
 * 截取字符串
 * @param {string} str
 * @param {number} len
 * @return {string}
 */

export function cutStrWithEmoji(str, len) {
  if (typeof str !== 'string') {
    return str;
  }

  var length = 0;
  var strArr = Array.from(str); // ES6的Array.from支持代理对的解析

  var strArrlen = strArr.length;
  var result = ''; // eslint-disable-next-line no-plusplus

  for (var i = 0; i < strArrlen; i++) {
    var item = strArr[i];
    length += 1;

    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length += 1;
    }

    result = result.concat(item);

    if (length >= len) {
      if (i === strArrlen - 1) {
        return result;
      }

      result = result.concat('...');
      return result;
    }
  }

  return str;
}
export function replaceUrl(href) {
  if (!href) {
    return;
  }

  var _window = window,
      location = _window.location,
      history = _window.history;
  var result = location.protocol + removeHttp(href);

  if (history.replaceState) {
    history.replaceState(null, document.title, result);
    location.replace('');
  } else {
    location.replace(result);
  }
}
export function getDefaultAvatar() {
  return '//thirdqq.qlogo.cn/g?b=sdk&k=4Hfd8rBxU0Nz2cIoFCMQRg&s=100&t=0';
}
export function fixShareConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = arguments.length > 1 ? arguments[1] : undefined;
  return {
    title: parseTemplate(config.分享标题, data),
    timeLineTitle: parseTemplate(config.分享朋友圈标题, data),
    desc: parseTemplate(config.分享描述, data),
    imgUrl: config.分享图,
    link: config.分享链接
  };
}